export default {
  cashCards: [],
  favCashCards: [],
  dummyFavCashCards: [],
}
